/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { colors } from "../../styles/defaultColors";
import { Container } from "@material-ui/core";
import { createData, Data, ListTable } from "./components/List/ListTable";
import { ContextMenu } from "./components/ContextMenu";
import { PropertyService } from "./services/PropertyService";
import { IAnnounce } from "../../utils/AnnounceInterfaces";
import { ShowConfirmDialog } from "../components/ShowConfirmDialog";
import SessionHandler from "../../https/SessionHandler";
import { UserContext } from "../../contexts/AppContext";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import { EAnnounceStatus } from "../../utils/enum";
// import { annnonceAdPaymentDefaultValue } from "../../utils/defaultNullValues";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        listProperty: {},
        properties: {
            width: "100%",
            minHeight: 1000,
            textAlign: "center",

            [theme.breakpoints.down("sm")]: {
                minHeight: 100,
            },
        },
        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
            textAlign: "center",
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            maxWidth: "60%",
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        showErrors: {},
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            maxWidth: "60%",
            display: "flex",
            justifyContent: "space-between",

            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },

        btn: {
            width: 180,
            height: 40,
            color: "#FFFFFF",
            textTransform: "initial",
            fontSize: 14,
            fontFamily: "Josefin Sans",
            marginBottom: 18,
            borderRadius: 100,
            background: "#890608",
            "&:hover": {
                background: "#EA7606",
            },
        },
        linkContainerButton: {
            textDecoration: "none",
        },
        loading: {
            width: "100%",
            position: "absolute",
            top: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            left: 0,
        },
    })
);

const propertyService = new PropertyService();
export const ListProperty = () => {
    const classes = styles();
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [currentRow, setCurrentRow] = React.useState<Data>();
    const [properties, setProperties] = React.useState<Data[]>([]);
    const [loadingPage, setLoadingPage] = React.useState(true);
    const [selected, setSelected] = React.useState<string[]>([]);
    const [deleteMultiple, setDeleteMultiple] = React.useState<boolean>(false);
    const history = useHistory();
    const { t } = useTranslation();

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openAllowDialog, setOpenAllowDialog] = React.useState(false);
    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                    }
                })
                .catch((err) => {
                    history.push("/");
                });
        } else {
            propertyService
                .getListAnnounces({ owner: user._id })
                .then((response) => {
                    setProperties(
                        response.data.map((announce: IAnnounce , index: number) => {

                            //console.log(announce);
                            if (index < 3) {
                                //console.log("ListProperty.tsx City (Sample):", announce.property?.address.city);
                                //console.log("ListProperty.tsx City Name (Sample):", announce.property?.address.city?.name);
                                //console.log("ListProperty.tsx Country (Sample):", announce.property?.address.country);
                                //console.log("ListProperty.tsx Country Name (Sample):", announce.property?.address.country?.name);
                            }            

                            return createData(
                                announce._id ? announce._id : "",
                                announce._idRef ? announce._idRef : "",
                                announce.property?.photos.length
                                    ? announce.property?.photos[0].filename
                                    : "",
                                announce.property?.name,
                                announce.property?.type.label
                                    ? t(announce.property?.type.label)
                                    : announce.property?.type.name,
                                announce.property?.maximumGuests,
                                announce.price,
                                announce.state,
                                announce.superOffer,
                                announce.property?.address.country?.name,
                                announce.property?.address.city?.name || "-",
                                announce.property?.address.quartier,
                                announce.devise,
                                announce.property?.hotel !== null 
                                    ? typeof announce.property?.hotel === "string" 
                                        ? announce.property.hotel 
                                        : announce.property?.hotel?._id ?? "" 
                                    : "",
                                announce.createdAt ? new Date(announce.createdAt).toLocaleDateString() : "", // Convert Date to string
                                announce.property?.type.searchType?.name ?? "" // Ensure it handles undefined/null safely
                                
                            );
                        })
                    );
                    setLoadingPage(false);
                })
                .catch((error) => {
                    console.log("Error properties", error);
                    setLoadingPage(false);
                });
        }
    }, []);
    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                    }
                })
                .catch((err) => {
                    history.push("/");
                });
        } else {
            propertyService
                .getListAnnounces({ owner: user._id })
                .then((response) => {
                    setProperties(
                        response.data.map((announce: IAnnounce) => {
                            //console.log(announce);

                            return createData(
                                announce._id ? announce._id : "",
                                announce._idRef ? announce._idRef : "",
                                announce.property?.photos.length
                                    ? announce.property?.photos[0].filename
                                    : "",
                                announce.property?.name,
                                announce.property?.type.label
                                    ? t(announce.property?.type.label)
                                    : announce.property?.type.name,
                                announce.property?.maximumGuests,
                                announce.price,
                                announce.state,
                                announce.superOffer,
                                announce.property?.address.country?.name,
                                announce.property?.address.city?.name || "-",
                                announce.property?.address.quartier,
                                announce.devise,
                                announce.property?.hotel !== null 
                                    ? typeof announce.property?.hotel === "string" 
                                        ? announce.property.hotel 
                                        : announce.property?.hotel?._id ?? "" 
                                    : "",
                                announce.createdAt ? new Date(announce.createdAt).toLocaleDateString() : "", // Convert Date to string
                                announce.property?.type?.searchType?.name ?? "" // Ensure it handles undefined/null safely
                            );
                        })
                    );
                    setLoadingPage(false);
                })
                .catch((error) => {
                    console.log("Error properties", error);
                    setLoadingPage(false);
                });
        }
    }, [setProperties, setLoadingPage, user, history, isConnected, setUser]);

    const handleClickOpenContextMenu = (
        event: React.MouseEvent<HTMLAnchorElement>,
        row: Data
    ) => {
        setCurrentRow(row);
        setAnchorEl(event.currentTarget);
    };

    const refreshPropertiesList = (id?: string) => {
        if (id) {
            setProperties(properties.filter((property) => property.id !== id));
        } else {
            setLoadingPage(true);
            propertyService
                .getListAnnounces({ owner: user._id })
                .then((response) => {
                    setProperties(
                        response.data.map((announce: IAnnounce) => {
                            //console.log(announce);

                            return createData(
                                announce._id ? announce._id : "",
                                announce._idRef ? announce._idRef : "",
                                announce.property?.photos.length
                                    ? announce.property?.photos[0].filename
                                    : "",
                                announce.property?.name,
                                announce.property?.type.label
                                    ? t(announce.property?.type.label)
                                    : announce.property?.type.name,
                                announce.property?.maximumGuests,
                                announce.price,
                                announce.state,
                                announce.superOffer,
                                announce.property?.address.country?.name,
                                announce.property?.address.city?.name || "-",
                                announce.property?.address.quartier,
                                announce.devise,
                                announce.property?.hotel !== null
                                    ? typeof announce.property?.hotel === "string"
                                        ? announce.property.hotel
                                        : announce.property?.hotel?._id ?? ""
                                    : "",
                                announce.createdAt ? new Date(announce.createdAt).toLocaleDateString() : "",
                                announce.property?.type?.searchType?.name ?? "" // Ensure it handles undefined/null safely
                            );
                        })
                    );

                    setLoadingPage(false);
                })
                .catch((error) => {
                    setLoadingPage(false);
                });
        }
    };
    const handleCloseContextMenu = () => {
        setAnchorEl(null);
    };

    const handleDeleteSelectedRow = () => {
        handleClickOpenDialog();
        setDeleteMultiple(true);
    };

    const handleClickOpenAllowDialog = () => {
        setOpenAllowDialog(true);
    };

    const handleClickConfirmAllowDialog = () => {
        handleAllowListing(
            currentRow?.id ?? "",
            currentRow?.state === EAnnounceStatus.SuspendedByUser ? true : false
        );
    };

    const handleClickConfirmDialog = () => {
        if (deleteMultiple) {
            if (selected.length) deleteMany();
        } else {
            if (currentRow) deleteOne(currentRow?.id);
        }
    };

    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCloseAllowDialog = () => {
        setOpenAllowDialog(false);
    };

    const deleteOne = (id: string) => {
        propertyService
            .deleteAnnounce(id)
            .then((response) => {
                if (response.success) {
                    setSelected(selected.filter((selId) => selId !== id));
                    refreshPropertiesList(id);
                }
                setDeleteMultiple(false);
            })
            .catch((error) => {
                console.log("list property context component error", error);
                setDeleteMultiple(false);
            });
        handleCloseDialog();
    };

    const deleteMany = () => {
        propertyService
            .deletesAnnounce(selected)
            .then((response) => {
                if (response.success) {
                    refreshPropertiesList();
                    setSelected([]);
                }
                setDeleteMultiple(false);
            })
            .catch((error) => {
                //console.log("list property context component error", error);
                setDeleteMultiple(false);
            });
        handleCloseDialog();
    };

    const handleAllowListing = (id: string, isAllowed: boolean) => {
        const newAnnounceState = isAllowed
            ? EAnnounceStatus.Published
            : EAnnounceStatus.SuspendedByUser;
        propertyService
            .allowOrBlockAnnoncePublishing(id, newAnnounceState)
            .then((response) => {
                if (response.success) {
                    refreshPropertiesList();
                }
            })
            .catch((error) => {
                console.log("Allow or block listing publishing error", error);
            });
        handleCloseAllowDialog();
    };

    const confirmDialog = ShowConfirmDialog({
        open: openDialog,
        handleClose: handleCloseDialog,
        handleConfirm: handleClickConfirmDialog,
        title:
            selected.length > 1
                ? t("propriete.confirmDialog.title-pluriel")
                : t("propriete.confirmDialog.title"),
        description:
            selected.length > 1
                ? t("propriete.confirmDialog.description-pluriel")
                : t("propriete.confirmDialog.description"),
    });
    const confirmAllowDialog = ShowConfirmDialog({
        open: openAllowDialog,
        handleClose: handleCloseAllowDialog,
        handleConfirm: handleClickConfirmAllowDialog,
        title:
            currentRow?.state === EAnnounceStatus.Published
                ? t("propriete.confirmAllowDialog.title.desactiver")
                : t("propriete.confirmAllowDialog.title.activer"),
        description:
            currentRow?.state === EAnnounceStatus.Published
                ? t("propriete.confirmAllowDialog.description.desactiver")
                : t("propriete.confirmAllowDialog.description.activer"),
    });
    return (
        <div className={classes.listProperty}>
            <Container>
                <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                            variant="h5"
                            gutterBottom
                            className={classes.propertiesTitle}
                        >
                            {t("menuUser.mesAnnonces")}
                        </Typography>
                        <Link
                            to="/category"
                            className={classes.linkContainerButton}
                        >
                            <Button variant="text" className={classes.btn}>
                                {t("listTable.button.creerUneAnnonce")}
                            </Button>
                        </Link>
                        {loadingPage && (
                            <div className={classes.loading}>
                                <PropagateLoader color="#36D7B7" size={15} />
                            </div>
                        )}
                        {!loadingPage && (
                            <ListTable
                                openContextMenu={handleClickOpenContextMenu}
                                properties={properties}
                                handleDeleteMultipleRow={
                                    handleDeleteSelectedRow
                                }
                                selected={selected}
                                setSelected={setSelected}
                            />
                        )}

                        <ContextMenu
                            handleClose={handleCloseContextMenu}
                            handleDeleteRow={handleClickOpenDialog}
                            handleAllowRow={handleClickOpenAllowDialog}
                            open={open}
                            anchorEl={anchorEl}
                            row={currentRow}
                        />
                        {confirmDialog}
                        {confirmAllowDialog}
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};
